/**
 * Оборачивает контент страницы: пока ready=false, контент невидим (виден только фон).
 * Когда ready=true, контент плавно появляется.
 * Лоадеры не показываем — экран остаётся сплошным цветом до появления контента.
 * Стили в style.css: у :not(.isReady) pointer-events: none, чтобы скролл родителя (#list и т.д.)
 * в мобильном WebView не ломался из‑за слоя с opacity: 0.
 */
export function PageReveal({ ready, children, className = "" }) {
  return (
    <div className={`pageContent ${ready ? "isReady" : ""} ${className}`.trim()}>
      {children}
    </div>
  );
}
